export default "__VITE_ASSET__b97ef5f1__"